module.exports = __webpack_public_path__ + "static/lova-prod-alt-gorsel-be915dd77425b166082a5ee749e9dc7b.webp";